import { BaseModel } from './base.model';

const STATUS_CALENDAR_PENDING = 'pending' as const;
const STATUS_CALENDAR_SENDED = 'sended' as const;
const STATUS_CALENDAR_ANSWERED = 'answered' as const;

export const StatusCalendar = {
  [STATUS_CALENDAR_PENDING]: STATUS_CALENDAR_PENDING,
  [STATUS_CALENDAR_SENDED]: STATUS_CALENDAR_SENDED,
  [STATUS_CALENDAR_ANSWERED]: STATUS_CALENDAR_ANSWERED,
} as const;

export type StatusCalendar = keyof typeof StatusCalendar;

const GRATEFUL_STATUS_CALENDAR_PENDING = 'pending' as const;
const GRATEFUL_STATUS_CALENDAR_SENDED = 'sended' as const;

export const GratefulStatus = {
  [GRATEFUL_STATUS_CALENDAR_PENDING]: GRATEFUL_STATUS_CALENDAR_PENDING,
  [GRATEFUL_STATUS_CALENDAR_SENDED]: GRATEFUL_STATUS_CALENDAR_SENDED,
};

export type GratefulStatus = keyof typeof GratefulStatus;

const CALENDAR_FILTER_BY_BY_MONTH = 'byMonth' as const;
const CALENDAR_FILTER_BY_BY_DATE_START = 'byDateStart' as const;
const CALENDAR_FILTER_BY_BY_DATE_END = 'byDateEnd' as const;
const CALENDAR_FILTER_BY_BY_CONTACT = 'byContact' as const;
const CALENDAR_FILTER_BY_BY_COLLECT = 'byCollect' as const;

export const CalendarFilterBy = {
  [CALENDAR_FILTER_BY_BY_MONTH]: CALENDAR_FILTER_BY_BY_MONTH,
  [CALENDAR_FILTER_BY_BY_DATE_START]: CALENDAR_FILTER_BY_BY_DATE_START,
  [CALENDAR_FILTER_BY_BY_DATE_END]: CALENDAR_FILTER_BY_BY_DATE_END,
  [CALENDAR_FILTER_BY_BY_CONTACT]: CALENDAR_FILTER_BY_BY_CONTACT,
  [CALENDAR_FILTER_BY_BY_COLLECT]: CALENDAR_FILTER_BY_BY_COLLECT,
};

export type CalendarFilterBy = keyof typeof CalendarFilterBy;

type CalendarFilters = Record<CalendarFilterBy, string>;

/**
 * Confirmacoes de envio, uma por dia da janela, indexadas por YYYY-MM-DD --
 * mesmo formato de `filters.byDateStart`. O valor e o instante da confirmacao.
 */
type CalendarSends = Record<string, string>;

type CalendarModel = Omit<BaseModel<string>, 'createdAt' | 'updatedAt'> & {
  collectNumber: number;
  filters: CalendarFilters;
  contactId: string;
  collectId: string;
  startAt: string;
  endAt: string;
  status: StatusCalendar;
  answeredAt?: string;
  gratefulStatus?: GratefulStatus;
  /**
   * Controle de envio por dia, separado de `status`.
   *
   * `status` responde em que pe esta a coleta; este mapa responde o que ainda
   * falta contatar hoje. Ausente significa nenhum envio registrado, e o contato
   * aparece como pendente -- inclusive em evento anterior a este controle.
   */
  sends?: CalendarSends;
};

type CalendarIndexModel = Omit<BaseModel<string>, 'createdAt' | 'updatedAt'> & {};

export type { CalendarIndexModel, CalendarModel, CalendarSends };
